export const EMAIL_STORAGE_KEY = "emailForSignIn";
export const CURRENT_TEAM_ID_KEY = "currentTeamId";
export const BACKEND_API_KEY = "abcd1023";

export const BACKEND_API_KEY_STARTER = "3f31f41515e84b15a7dd40487845e1c5";
export const BACKEND_API_KEY_UNLIMITED = "d6a67b5d6d934464b1f242ae36c35018";
